/**
 * Match a stored credential key to an Integrations card.
 *
 * X and X Ads must use exact secret-name segments; substring matching would
 * otherwise make `{owner}--xcom-ads--...` appear on both cards.
 */
export const integrationKeyMatches = (integrationId: string, keyId: string): boolean => {
  const segment = String(keyId).split('--')[1] || ''
  if (integrationId === 'xcom') return segment === 'xcom'
  if (integrationId === 'xcom_ads') return segment === 'xcom-ads' || segment === 'xcom_ads'
  if (keyId.includes(integrationId)) return true
  return (
    keyId.includes(integrationId.replace(/_/g, '-')) ||
    keyId.includes(integrationId.replace(/-/g, '_'))
  )
}
